module.exports = __webpack_public_path__ + "static/img/magento.52002bb7.png";